import script from "./Price.vue?vue&type=script&setup=true&lang=js"
export * from "./Price.vue?vue&type=script&setup=true&lang=js"

import "./Price.vue?vue&type=style&index=0&id=706ddf73&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-706ddf73"]])

export default __exports__